import { ServicePage } from "@/components/ServicePage";
import { ValutaForm } from "@/components/LeadForms";
import { ExternalLink } from "lucide-react";

export default function AgenziaImmobiliare() {
  return (
    <ServicePage
      eyebrow="Compravendite & Affitti"
      title="Agenzia Immobiliare a Scandicci"
      intro="Benvenuti nell'Agenzia Immobiliare Edilstudio a Scandicci: la vostra porta d'ingresso per una vasta gamma di proprietà in Toscana. Vi guidiamo nella compravendita, nell'affitto e nell'investimento immobiliare con competenza e dedizione, a Scandicci, Firenze e nelle aree circostanti."
      image="/img/svc-agenzia.jpg"
      seoTitle="Agenzia Immobiliare Scandicci e Firenze | Vendita, Affitto, Valutazioni | Edilstudio"
      seoDesc="Agenzia immobiliare a Scandicci: compravendite, affitti, valutazioni precise, gestione immobili, verifiche di solvibilità e registrazione contratti. Esperti locali del mercato toscano."
      canonical="/agenzia-immobiliare-scandicci/"
      keywords={["Compravendite", "Affitti", "Valutazioni Immobiliari", "Gestione Immobili", "Verifiche Solvibilità", "Registrazione Contratti"]}
      services={[
        { title: "Compravendite e affitti", text: "Compravendita e affitto di proprietà residenziali e commerciali nella pittoresca Toscana, con assistenza personalizzata per ogni cliente." },
        { title: "Valutazioni immobiliari", text: "Valutazioni precise degli immobili e strategie di marketing efficaci, all'insegna di trasparenza e professionalità." },
        { title: "Approccio personalizzato", text: "Ascolto attento delle esigenze dei clienti e ricerca delle soluzioni più adatte, con consulenze approfondite e supporto costante in ogni fase." },
        { title: "Esperienza locale", text: "Radici solide nel tessuto sociale e immobiliare di Scandicci: conoscenza approfondita del mercato per individuare opportunità uniche." },
        { title: "Gestione e contratti", text: "Gestione immobili, verifiche di solvibilità e registrazione dei contratti: seguiamo ogni adempimento con cura." },
        { title: "Investimenti", text: "Consulenza per investimenti immobiliari a Scandicci, Firenze e nelle aree circostanti." },
      ]}
    >
      <section className="max-w-4xl mx-auto px-4 sm:px-6 -mt-6 pb-4">
        <a href="https://www.immobiliare.it/agenzie-immobiliari/207905/edilstudio-scandicci/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between gap-4 bg-[#1B2A41] text-white rounded-2xl p-6 hover:bg-[#24344F] transition-colors" data-testid="immobiliare-vetrina">
          <div>
            <div className="font-display text-lg font-bold">Esplora la nostra vetrina su Immobiliare.it</div>
            <p className="text-white/70 text-sm mt-1">Un'ampia selezione di case, appartamenti e uffici, con dettagli e immagini.</p>
          </div>
          <ExternalLink className="w-6 h-6 shrink-0" />
        </a>
      </section>
      <section className="bg-[#EEF4F9] py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <h2 className="font-display text-3xl font-bold text-[#1B2A41] text-center">Contattaci per una valutazione gratuita</h2>
          <p className="text-center text-[#566476] mt-3">Raccontaci del tuo immobile: ti ricontattiamo con una valutazione senza impegno.</p>
          <div className="bg-white rounded-2xl border border-[#DCE6EF] p-6 sm:p-8 mt-8">
            <ValutaForm />
          </div>
        </div>
      </section>
    </ServicePage>
  );
}
